import React, { useState, useEffect } from 'react';
import { checkAuthStatus } from '../utills/authChecker';
import { useNavigate } from 'react-router-dom'; // Import useNavigate
import styles from '../search.module.css';
import CustomeAlertBox from './CustomeAlertBox';
import logo from '../assets/11.png';


export default function Navbar() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [alertMessage, setAlertMessage] = useState('');
  const [authStatus, setAuthStatus] = useState({ isLoggedIn: false, isAdmin: false });
  const navigate = useNavigate();

  useEffect(() => {
    const status = checkAuthStatus();
    setAuthStatus(status);
  }, []);

  const toggleModal = () => {
    setIsModalOpen(!isModalOpen);
    document.body.style.overflow = isModalOpen ? 'auto' : 'hidden';
  };

  const closeModal = (e) => {
    if (e.target.classList.contains(styles.modalOverlay)) {
      toggleModal();
    }
  };

  const handleLogin = () => {
    navigate('/login');
  };
  const handleLogout = () => {
    localStorage.removeItem('adminToken');
    localStorage.removeItem('refreshToken');
    setAlertMessage('Successfully logged out');
  };
  const closeAlert = () => {
    setAlertMessage('');
    const status = checkAuthStatus();
    setAuthStatus(status);
    window.location.reload();
  };

  const routeHome = () => {
    navigate('/');
  };
  const routeDownloadhistory = () => {
    navigate('/downloadhistory');
  };

  return (
    <>
      <nav className={styles.navbar}>
        <div className={styles.navContent}>
          <div className={styles.leftNav}>
            <img src={logo} alt="Logo" className={styles.logo} />
            <ul className={styles.navLinks}>
              <li><div className={styles.navTabs} onClick={routeHome}>Home</div></li>
              <li><a href="#products">Products</a></li>
              <li><a href="#about">About Us</a></li>
              <li><a href="#company">Company</a></li>
              {/* {authStatus.isLoggedIn && authStatus.isAdmin && (<li><div className={styles.navTabs} onClick={routeDownloadhistory}>Download</div></li>)} */}
            </ul>
          </div>
          <div className={styles.rightNav}>
            {!authStatus.isLoggedIn && (<button className={styles.signupButton} onClick={handleLogin}>Login</button>)}
            {authStatus.isLoggedIn && authStatus.isAdmin && (<button className={styles.signupButton} onClick={handleLogout}>Logout</button>)}
            <div className={styles.mobileMenu}>
              <button className={styles.menuButton} aria-label="Menu" onClick={toggleModal}>
                <span className={`${styles.menuIcon} ${isModalOpen ? styles.menuIconActive : ''}`}></span>
              </button>
            </div>
          </div>
        </div>
      </nav>

      {isModalOpen && (
        <div className={styles.modalOverlay} onClick={closeModal}>
          <div className={styles.modalContent}>
            <div className={styles.modalHeader}>
              <img src={logo} alt="Logo" className={styles.modalLogo} />
              <button className={styles.closeButton} onClick={toggleModal}>&times;</button>
            </div>
            <ul className={styles.modalNavLinks}>
              <li><div className={styles.navTabs} onClick={routeHome}>Home</div></li>
              <li><a href="#products" onClick={toggleModal}>Products</a></li>
              <li><a href="#about" onClick={toggleModal}>About Us</a></li>
              <li><a href="#company" onClick={toggleModal}>Company</a></li>
              {/* {authStatus.isLoggedIn && authStatus.isAdmin && (<li><div className={styles.navTabs} onClick={routeDownloadhistory}>Download</div></li>)} */}
            </ul>
            <div className={styles.modalButtons}>
              {!authStatus.isLoggedIn && (<button className={styles.modalSignupButton} onClick={handleLogin}>Login</button>)}
              {authStatus.isLoggedIn && authStatus.isAdmin && (<button className={styles.signupButton} onClick={handleLogout}>Logout</button>)}
            </div>
          </div>
        </div>
      )}
      {alertMessage && <CustomeAlertBox message={alertMessage} onClose={closeAlert} />}
    </>
  );
}
